<template>
  <img :src="setImgUrl" @error="imgError"/>
</template>

<script>
import { mapState } from 'vuex'
import { BASE_URL } from '@/assets/scripts/api'

export default {
  data () {
    return {
      flag: false
    }
  },
  props: {
    cdn: Boolean,
    src: {
      type: String,
      default: ''
    },
    errorImg: {
      type: String,
      default: '/images/default.png'
    }
  },
  computed: {
    setImgUrl () {
      if (!this.cdn) {
        return BASE_URL + this.src
      } else {
        return this.imageResourcesUrl + this.src
      }
    },
    ...mapState({
      imageResourcesUrl: state => state.imageResourcesUrl
    })
  },
  methods: {
    imgError () {
      this.$el.setAttribute('src', BASE_URL + this.errorImg)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
